import { testnetApiStages } from '@/Config/ApiConfig';

const TESTNET_API_URL = testnetApiStages['production'];
/**
 * Testnet networks on "Home" page
 */
export const testnetNetworks = [
  {
    id: 'adfe993b-880c-4472-a347-a6e1db5558ea',
    name: 'Shardeum Sphinx',
    chainId: '8082',
    network_image_url: TESTNET_API_URL + '/static/networks/shardeum.png',
    blockscan_url: 'https://explorer-sphinx.shardeum.org/',
    token_symbol: 'SHM',
    token_decimals: 18,
    // network_type: NetworkTypes.EVM,
    is_rpc: true,
    rpc_url: 'https://sphinx.shardeum.org',
    category: 'L1 EVM Networks',
    tag: 'Testnet',
    is_coming_soon: false,
    is_testnet: true,
  },
  /*  {
    id: 'e5931d72-4022-4fde-96c2-2ca5e6e480b3',
    name: 'Berachain Artio',
    chainId: '80085',
    network_image_url: TESTNET_API_URL + '/static/networks/berachainArtio.png',
    blockscan_url: 'https://artio.beratrail.io/',
    token_symbol: 'BERA',
    token_decimals: 18,
    // network_type: NetworkTypes.EVM,
    is_rpc: true,
    rpc_url: 'https://artio.rpc.berachain.com',
    category: 'Innovative Networks',
    tag: 'Testnet',
    is_coming_soon: false,
    is_testnet: true,
  }, */
];
